import { useMemo } from "react";
import EndpointStatusChart from "../../../../SiteExplorer/Pages/Endpoints/EndpointStatusChart";
import NoDataPage from "../../Pages/NoDataPage";
import { enMessages } from "../../../../../messages/en-US";
import { useLocalization } from "@progress/kendo-react-intl";

interface Props {
  deviceHealthData: any;
  selectedEndpointId: string;
  eventFilter: any;
  setEventFilter: any;
  chartParentHeight: number;
  deviceInfo: any;
  deviceNotifications: any;
}

export default function HeadUnitHealthDetails(props: Props) {
    const localizationService = useLocalization();

    // The chart snapshots its data on mount, so it must remount when the date range changes
    const rangeKey = `${props.eventFilter?.startDate?.getTime?.() ?? ''}:${props.eventFilter?.endDate?.getTime?.() ?? ''}`;
    const statusData = {
        dateFilter: props.eventFilter,
        timestamps: props.deviceNotifications?.timestamps,
        alerts: {
             timestamps: props.deviceNotifications?.timestamps,
             yValues: new Array(props.deviceNotifications?.timestamps?.length).fill(1),
             metadata: props.deviceNotifications?.metadata
         },
         statusData: {
             id: "",
             timestamps: [],
             yValues: [],
             metadata:[
                 {
                     color: "#FFFFFF",
                     reasonCode: 0
                 },
                 {
                     color: "#00A2E8",
                     reasonCode: 0
                 }
             ]
         }
     }

    const timelineData = useMemo(() => {
        if (!props.deviceInfo || props.deviceInfo.length === 0) {
            return {
                seriesData: [],
                dateFilter: props.eventFilter,
                aggregator: 'none',
                strokeThickness: 1
            };
        }

        // Extract timestamps and convert to Unix timestamps
        const deviceInfoTimestamps = props.deviceInfo.map(device => 
            Math.floor(new Date(device.timestampUtc).getTime() / 1000)
        );
        const flowEventsTimestamps = props.deviceHealthData.headUnitFlowEvents.map(device => 
            Math.floor(new Date(device.occurred).getTime() / 1000)
        );

        // Extract device data for tooltips
        const serialNumbers = props.deviceInfo.map(device => device?.serialNo || "Unknown");
        const firmwareVersions = props.deviceInfo.map(device => device?.firmwareVersion || "Unknown");
        const modelNumbers = props.deviceInfo.map(device => device?.modelNo || "Unknown");
        const volumesDispensed = props.deviceHealthData.headUnitFlowEvents.map(device => device?.volumeDispensed || "Unknown");
        

        return {
          seriesData: [
            {
              id: "HeadUnitFlowEvents",
              name: localizationService.toLanguageString('custom.flowEvents', enMessages.custom.flowEvents),
              color: "rgba(50, 53, 67,1)",
              timestamps: flowEventsTimestamps,
              yAxisValueArray: new Array(flowEventsTimestamps?.length).fill(2),
              tooltips: [
              {
                name: localizationService.toLanguageString('custom.volumeDispensed', enMessages.custom.volumeDispensed),
                data: volumesDispensed,
                color: "rgba(50, 53, 67,1)"
              }],
            },
            {
              id: "HeadUnitId",
              name: localizationService.toLanguageString('custom.deviceInfoEvents', enMessages.custom.deviceInfoEvents),
              color: "#FF7F27",
              timestamps: deviceInfoTimestamps,
              yAxisValueArray: new Array(deviceInfoTimestamps?.length).fill(1),
              tooltips: [{
                name: localizationService.toLanguageString('custom.serialNumber', enMessages.custom.serialNumber),
                data: serialNumbers,
                color: "rgba(50, 53, 67,1)"
              },
              {
                name: localizationService.toLanguageString('custom.firmwareVersion', enMessages.custom.firmwareVersion),
                data: firmwareVersions,
                color: "#00A2E8"
              },
              {
                name: localizationService.toLanguageString('custom.modelNumber', enMessages.custom.modelNumber),
                data: modelNumbers,
                color: "#00A2E8"
              },
            ],
            },
            

          ],
          dateFilter: props.eventFilter,
          aggregator: 'none',
          strokeThickness: 1
        };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.deviceInfo, props.eventFilter]);

  return (
    <div className="legend-column">
    {timelineData.seriesData.length > 0 ?(
      <EndpointStatusChart
        chartType="timeline"
        key={`${props.selectedEndpointId}-timeline-${rangeKey}`}
        timelineData={timelineData}
        isSimpleChart={false}   
        chartParentHeight={props.chartParentHeight}
        statusChartData={statusData}
        showStatus={false}
        isLegendColumn={true}
      />
      ) : (
        <div className="flex justify-center items-center h-full">
          <NoDataPage />
        </div>
      )}
    </div>
  );
}